/* eslint-disable */
var lotteryData = null;
var lotteryStatusAjax = false;
let checkLotteryService = function (callback, isMobile) {
	var getLotteryStatus = function () {
		var options = {
			url: appConfig.gatewayUrl + '/apiV1/lottery/findActive',
			dataType: 'jsonp',
			data: {
				isMobile: isMobile ? 1 : 0,
				showcase: appConfig.showcaseCode || ''
			},
		};

		lotteryStatusAjax = $.ajax(options);
	};

	callback = callback ? callback : function () {
	};

	if (_.isNull(lotteryData)) {
		if (!lotteryStatusAjax) {
			getLotteryStatus();
		}

		$.when(lotteryStatusAjax).then(function (response) {
			if (response.success && response.data) {
				lotteryData = response.data;
			} else {
				lotteryData = false;
			}
			callback(lotteryData);
		}, function () {
			lotteryData = false;
			callback(lotteryData);
		});
	} else {
		callback(lotteryData);
	}

	return lotteryData;
};

export default checkLotteryService;